/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Board_Refund_SuccessInputs */

const en_delivery_board_refund_success = /** @type {(inputs: Delivery_Board_Refund_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order refunded and cancelled. Funds are being returned to the buyer.`)
};

const es_delivery_board_refund_success = /** @type {(inputs: Delivery_Board_Refund_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedido reembolsado y cancelado. Los fondos se están devolviendo.`)
};

const fr_delivery_board_refund_success = /** @type {(inputs: Delivery_Board_Refund_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commande remboursée et annulée. Les fonds sont retournés à l'acheteur.`)
};

const de_delivery_board_refund_success = /** @type {(inputs: Delivery_Board_Refund_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellung erstattet und storniert. Das Geld wird an den Käufer zurückgegeben.`)
};

const id_delivery_board_refund_success = /** @type {(inputs: Delivery_Board_Refund_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesanan dikembalikan dan dibatalkan. Dana sedang dikembalikan ke pembeli.`)
};

/** @type {(inputs: Delivery_Board_Refund_SuccessInputs) => LocalizedString} */
const ja_delivery_board_refund_success = en_delivery_board_refund_success;

/** @type {(inputs: Delivery_Board_Refund_SuccessInputs) => LocalizedString} */
const zh_delivery_board_refund_success = en_delivery_board_refund_success;

/** @type {(inputs: Delivery_Board_Refund_SuccessInputs) => LocalizedString} */
const ar_delivery_board_refund_success = en_delivery_board_refund_success;

/** @type {(inputs: Delivery_Board_Refund_SuccessInputs) => LocalizedString} */
const it_delivery_board_refund_success = en_delivery_board_refund_success;

/** @type {(inputs: Delivery_Board_Refund_SuccessInputs) => LocalizedString} */
const ru_delivery_board_refund_success = en_delivery_board_refund_success;

/** @type {(inputs: Delivery_Board_Refund_SuccessInputs) => LocalizedString} */
const pt_delivery_board_refund_success = en_delivery_board_refund_success;

/** @type {(inputs: Delivery_Board_Refund_SuccessInputs) => LocalizedString} */
const ko_delivery_board_refund_success = en_delivery_board_refund_success;

/**
* | output |
* | --- |
* | "Order refunded and cancelled. Funds are being returned to the buyer." |
*
* @param {Delivery_Board_Refund_SuccessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_board_refund_success = /** @type {((inputs?: Delivery_Board_Refund_SuccessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Board_Refund_SuccessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_board_refund_success(inputs)
	if (locale === "es") return es_delivery_board_refund_success(inputs)
	if (locale === "fr") return fr_delivery_board_refund_success(inputs)
	if (locale === "de") return de_delivery_board_refund_success(inputs)
	if (locale === "ja") return ja_delivery_board_refund_success(inputs)
	if (locale === "zh") return zh_delivery_board_refund_success(inputs)
	if (locale === "ar") return ar_delivery_board_refund_success(inputs)
	if (locale === "id") return id_delivery_board_refund_success(inputs)
	if (locale === "it") return it_delivery_board_refund_success(inputs)
	if (locale === "ru") return ru_delivery_board_refund_success(inputs)
	if (locale === "pt") return pt_delivery_board_refund_success(inputs)
	return ko_delivery_board_refund_success(inputs)
});